import React, { memo, ReactElement } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import styles from './styles.module.scss';

interface NewCustomCssTransitionProps {
  bool: boolean;
  children?: React.ReactNode;
}

const NewCustomCssTransition: React.FC<NewCustomCssTransitionProps> = ({ bool, children }) => {
  const childCount = React.Children.count(children);
  const childElement: ReactElement =
    childCount === 1 ? (children as ReactElement) : <div>{children}</div>;

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={bool ? 'show' : 'unShow'}
        timeout={100}
        classNames={{
          enter: styles.fadeEnter,
          enterActive: styles.fadeEnterActive,
          exit: styles.fadeExit,
          exitActive: styles.fadeExitActive,
        }}
      >
        {childElement}
      </CSSTransition>
    </SwitchTransition>
  );
};

export default memo(NewCustomCssTransition);